
import {Inject, Injectable, OnDestroy, Optional} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import {Observable, Subject, takeUntil} from 'rxjs';
import {environment} from '../environments/environment';
import {getCurrentSsrRequestContext, SSR_REQUEST_CONTEXT, SsrRequestContext} from './ssr-request-context';

export class BaseInterceptor {
  public static doInterception (req: HttpRequest<any>, next: HttpHandler, cookieHeader?: string): Observable<HttpEvent<any>> {
    // only apply interceptor to api calls
    if (req.url.indexOf(environment.baseUrls().api) === 0) {
      const cloneOptions: {
        withCredentials: boolean;
        setHeaders?: { [name: string]: string };
      } = {
        withCredentials: true
      };
      if (cookieHeader && !req.headers.has('Cookie')) {
        cloneOptions.setHeaders = {
          Cookie: cookieHeader
        };
      }

      return next.handle(req.clone({
        ...cloneOptions
      }));
    } else {
      return next.handle(req);
    }
  }
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor, OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(
    @Optional() @Inject(SSR_REQUEST_CONTEXT) private ssrRequestContext: SsrRequestContext | null
  ) {
  }

  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let interceptedReq: HttpRequest<any> = req;
    const ssrRequestContext = this.getSsrRequestContext();
    if (ssrRequestContext && req.url.indexOf('http') !== 0) {
      let newUrl = ssrRequestContext.origin;
      if (!req.url.startsWith('/')) {
        newUrl += '/';
      }
      newUrl += req.url;
      interceptedReq = req.clone({url: newUrl, withCredentials: true});
    }

    return BaseInterceptor
      .doInterception(interceptedReq, next, this.getCookieHeader(ssrRequestContext))
      .pipe(takeUntil(this.destroy$));
  }

  private getSsrRequestContext(): SsrRequestContext | null {
    return this.ssrRequestContext ?? getCurrentSsrRequestContext();
  }

  private getCookieHeader(ssrRequestContext: SsrRequestContext | null): string | undefined {
    return ssrRequestContext?.cookieHeader || undefined;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
